import { History } from 'history';
import * as React from 'react';
import { Link } from 'react-router-dom';
import { NavigationInformation } from '../../Model/NavigationInformation';
import { RouteConstants } from '../../RouteConstants';
import { Type } from '../../Type';

interface BackButtonProps {
    text: string,
    className: string,
    type: Type,
    history: History
}

export class BackButton extends React.PureComponent<BackButtonProps> {
    public render() {
        const props = this.props;
        const combinedClassName = 'jc-sidebar-button-overview ' + props.className;
        const history = props.history;
        const text = props.text;

        // Check if the state indicates, that the Detail page is opened from the overview and **not** via a direct link
        const navigationState = history.location.state as undefined | NavigationInformation;
        if (navigationState && navigationState.fromOverview) {
            const historyBack = history.goBack;

            /* eslint-disable-next-line jsx-a11y/anchor-is-valid, no-script-url */
            return <a href="javascript:void(0)" onClick={historyBack} className={combinedClassName}>{text}</a>;
        } else {
            const to = RouteConstants.routeForType(props.type);

            return <Link to={to} className={combinedClassName}>{text}</Link>;
        }
    }
}
